const baseURL = "https://apijiujiu.watermelonpig.eu.org"

export default async function request(url, options) {
    let res = await fetch(baseURL + url, options)
    if (res.redirected) {
        res = await fetch(res.url, options)
    }
    return res
}